import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import Container from "hardcover-ui/components/Container";
import LoadingBook from "hardcover-ui/components/LoadingBook";
import RedirectProps from "./redirect.props";
import { router, usePage } from "@inertiajs/react";
import useMount from "hooks/useMount";
import TextLink from "hardcover-ui/components/TextLink";

function Redirect({ to }: { to: string }) {
  router.visit(to);
  return <TextLink href={to}>Redirecting...</TextLink>
}

function RedirectPage() {
  const { redirectTo } = usePage<RedirectProps>().props;
  const mounted = useMount();
  
  return (
    <Container variant="layout">
      <LoadingBook />

      {mounted && (
        <Redirect to={redirectTo} />
      )}
    </Container>
  );
}

RedirectPage.layout = DefaultLayoutWrapper;
export default RedirectPage;
